export function priceFormat(price) {
    return Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0
    }).format(price)
}
